module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('v-touch', {
    ref: "tapper",
    on: {
      "swiperight": _vm.prevGround,
      "swipeleft": _vm.nextGround
    }
  }, [_c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "inside products"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('products.headingTopText')))]), _vm._v(" "), _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.headingBottomText'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxes"
  }, [_c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "arrow arrow-prev",
    on: {
      "click": _vm.prevGround
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-next",
    on: {
      "click": _vm.nextGround
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "box farm-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'farm', next: _vm.mobileOption < 0, prev: _vm.mobileOption > 0
    },
    attrs: {
      "to": "/products/farms",
      "id": "farmGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.farmHover,
      "mouseleave": _vm.farmLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/home/wind-farm.svg"),
      "alt": "wind-farm"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.farms'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "box big airport-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'airport', next: _vm.mobileOption < 1, prev: _vm.mobileOption > 1
    },
    attrs: {
      "to": "/products/airport",
      "id": "airportGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.airportHover,
      "mouseleave": _vm.airportLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/airport.svg"),
      "alt": "airport"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.airports'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)\n                      ")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "box area-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'area', next: _vm.mobileOption < 2, prev: _vm.mobileOption > 2
    },
    attrs: {
      "to": "/products/area",
      "id": "forestGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.forestHover,
      "mouseleave": _vm.forestLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/home/area.svg"),
      "alt": "area"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.area'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])])])], 1)])]), _vm._v(" "), _c('router-link', {
    staticClass: "more-about-us",
    attrs: {
      "active-class": "active",
      "to": "/about"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('moreAboutUs')))])])], 1)]), _vm._v(" "), _c('FooterOrange')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d640b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Products.vue
// module id = 272
// module chunks = 0